import { useState, useEffect } from 'react';
import { ChevronUp } from 'lucide-react';
import { upvotePost, hasVoted, addVoted } from '@/lib/exchangeApi';

const UpvoteControl = ({ postId, count, large = false }) => {
  const [voted, setVoted] = useState(() => hasVoted(postId));
  const [c, setC] = useState(count);

  useEffect(() => setC(count), [count]);

  const vote = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (voted) return;
    setVoted(true);
    setC((n) => n + 1);
    addVoted(postId);
    try {
      const res = await upvotePost(postId);
      setC(res.upvotes);
    } catch {
      // optimistic value stays; ignore transient errors in event room
    }
  };

  return (
    <button
      onClick={vote}
      disabled={voted}
      data-testid={`upvote-btn-${postId}`}
      title={voted ? 'You upvoted this' : 'Upvote'}
      className={`flex flex-col items-center justify-center rounded-xl border transition-colors shrink-0 ${
        large ? 'w-14 py-2.5 gap-0.5' : 'w-11 py-2 gap-0.5'
      } ${
        voted
          ? 'bg-brand-orange/10 border-brand-orange text-brand-orange cursor-default'
          : 'bg-white border-black/10 text-ink-secondary hover:border-brand-orange hover:text-brand-orange'
      }`}
    >
      <ChevronUp size={large ? 22 : 18} strokeWidth={2.6} />
      <span
        data-testid={`upvote-count-${postId}`}
        className={`font-bold ${large ? 'text-base' : 'text-sm'}`}
      >
        {c}
      </span>
    </button>
  );
};

export default UpvoteControl;
